import React from "react";
import { Button, ButtonProps } from "../Button/Button";
import { Link } from "react-router-dom";

interface LinkButtonProps extends ButtonProps {
  linkTo: string;
  linkStyle?: React.CSSProperties;
}

export const LinkButton = React.forwardRef<HTMLButtonElement, LinkButtonProps>(
  ({ linkTo, linkStyle, ...rest }, ref) => {
    if (rest.disabled) return <Button {...rest} ref={ref} />;
    return (
      <Link to={linkTo} target={rest.target} style={{ textDecoration: "none", ...linkStyle }}>
        <Button {...rest} ref={ref} />
      </Link>
    );
  }
);
